<template>
    <div>
        <header id="header">
            <div class="wrapper site-header__wrapper">
                <router-link to="/"><div class="logo"><h1><img src="@/assets/tool-logo.png" /></h1></div></router-link>
            </div>
        </header>
    </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return{
    }
  }
}
</script>
<style scoped>
* {
    margin: 0;
}
#header{
    display: flex;
    justify-content: space-between;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.logo h1 img{
    max-height: 30vh;
    height: auto;
    width: 100%;
}
.wrapper{
    margin-left: auto;
    margin-right: auto;
}
@media (min-width: 630px){
#header{
    display: none;
}

.site-header__wrapper {
    justify-content: initial;
}
}
</style>